module.exports = __webpack_public_path__ + "img/stss.e159135c.png";